import { createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "bg-gray-400 flex h-screen w-full fixed items-center justify-center",
  style: {'left': '0px'}
}
const _hoisted_2 = { class: "flex flex-col modal-box w-96" }
const _hoisted_3 = { class: "flex justify-end w-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 11L11 1",
    stroke: "#222B45",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L11 11",
    stroke: "#222B45",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "flex flex-col gap-4 p-2 w-full" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center w-full" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Change Password")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-small" }, "After you change your Password, next time you need to login with the new one.", -1)
const _hoisted_9 = { class: "pwd" }
const _hoisted_10 = ["type", "rules"]
const _hoisted_11 = { class: "p-viewer" }
const _hoisted_12 = { class: "pwd" }
const _hoisted_13 = ["type", "rules"]
const _hoisted_14 = { class: "p-viewer" }
const _hoisted_15 = { class: "pwd" }
const _hoisted_16 = ["type", "rules"]
const _hoisted_17 = { class: "p-viewer" }
const _hoisted_18 = { class: "flex justify-end" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Update", -1)
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
          class: "modal-button-close"
        }, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            class: "form-field",
            type: _ctx.oldpassword,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.OldPassword) = $event)),
            rules: _ctx.passwordRules,
            placeholder: "OldPassword"
          }, null, 8, _hoisted_10), [
            [_vModelDynamic, _ctx.OldPassword]
          ]),
          _createElementVNode("span", _hoisted_11, [
            _createVNode(_component_font_awesome_icon, {
              icon: _ctx.sortHiddenA,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchVisibility('old')))
            }, null, 8, ["icon"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("input", {
            class: "form-field",
            type: _ctx.password,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.Password) = $event)),
            rules: _ctx.passwordRules,
            placeholder: "Current Password"
          }, null, 8, _hoisted_13), [
            [_vModelDynamic, _ctx.Password]
          ]),
          _createElementVNode("span", _hoisted_14, [
            _createVNode(_component_font_awesome_icon, {
              icon: _ctx.sortHiddenB,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.switchVisibility('current')))
            }, null, 8, ["icon"])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _withDirectives(_createElementVNode("input", {
            class: "form-field",
            type: _ctx.newpassword,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.RepeatPassword) = $event)),
            rules: _ctx.passwordRules,
            placeholder: "Current Password"
          }, null, 8, _hoisted_16), [
            [_vModelDynamic, _ctx.RepeatPassword]
          ]),
          _createElementVNode("span", _hoisted_17, [
            _createVNode(_component_font_awesome_icon, {
              icon: _ctx.sortHiddenC,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.switchVisibility('new')))
            }, null, 8, ["icon"])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", {
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.updatePassword && _ctx.updatePassword(...args))),
            class: "button"
          }, _hoisted_20)
        ])
      ])
    ])
  ]))
}